import React from "react";
import { Link } from "react-router-dom";

const MemberSection = () => {
  return (
    <>
      <section className="member-section padding-tb welcome-page bg-flower-img">
        <div className="container">
          {/* <div className="section-header">
            <h4 className="theme-color">{subtitle}</h4>
            <h2> {title}</h2>
          </div> */}
          <div className="section-wrapper">
            <div className="row justify-content-center g-3 g-md-4 align-items-center">
              {/* <MemberItem /> */}
              <div className="col-12 col-md-6">
                <img
                  src="assets/images/bat-img/welcome-img.svg"
                  alt="welcome image"
                />
              </div>
              <div className="col-12 col-md-6">
                <div className="right-content">
                  <div className="header">Welcome To BAT Matrimony</div>
                  <div className="text-content">
                    <p className="text mb-15">
                      BAT Matrimony is a one-stop spot for all your matrimonial
                      needs. We’re confident that you’ll be able to find your
                      PERFECT match!
                    </p>
                    <ul className="list-style mb-20">
                      <li>Exclusively for Hindu Brahmins</li>
                      <li>
                        Every user on our platform has been verified by an
                        expert team to make sure they are real and active
                      </li>
                      <li>
                        All matrimony profiles are protected and high privacy is
                        maintained. Multi-level authorization necessary to view
                        other profiles
                      </li>
                      <li>
                        With the help of this new search tool, you can find your
                        perfect match in no time! It has been designed to be
                        quick and efficient
                      </li>
                    </ul>
                    {/* <div className="button login-btn">
                      <Link to="/login">Login</Link> /{" "}
                      <Link to="/register">Register</Link>
                    </div> */}
                  </div>
                </div>
              </div>
            </div>
            {/* <div className="member-button-group d-flex flex-wrap justify-content-center">
              <Link to="/register" className="lab-btn">
                <i className="icofont-users"></i> <span>Join Us for Free</span>
              </Link>
              <Link to="/login" className="lab-btn">
                <i className="icofont-play-alt-1"></i>{" "}
                <span>Our tv commercial</span>
              </Link>
            </div> */}
          </div>
        </div>
      </section>
      <div className="section-break"></div>
    </>
  );
};

export default MemberSection;
